import type { Plan } from '@aibees/shared/definition';

/**
 * Whether a single plan is free.
 *
 * Backend emits the literal string "true" / "false" for is_free — a truthy
 * check would match both, so we have to compare against the literal "true".
 * `amount` is the fallback for plans that omit the flag entirely.
 */
export function isFreePlan(plan: Plan): boolean {
  return plan.metadata?.is_free === 'true' || !plan.amount;
}

/**
 * Whether the plan set behind one card is free — i.e. it has plans and every
 * one of them is free. A family mixing a free tier with paid tiers is NOT a
 * free card: it still shows a price and an upgrade CTA.
 *
 * Single source of truth for card free-ness. Both the card's `isFree` prop
 * (`usePlanList`) and its price/button copy (`buildPlanCardConfig`) derive from
 * this, so they can't disagree — previously the former checked "every plan is
 * free" while the latter checked only the cheapest plan, and a mixed family
 * rendered "Always free" copy on a card flagged as paid.
 */
export function isFreePlanSet(plans: Plan[]): boolean {
  return plans.length > 0 && plans.every(isFreePlan);
}
